// Moving lodash imports to here and importing individually
// rather than using the whole package (import _ from 'lodash'),
// significantly reduces bundle size.

import get from 'lodash/get';
import set from 'lodash/set';
import map from 'lodash/map';
import words from 'lodash/words';
import findIndex from 'lodash/findIndex';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import replace from 'lodash/replace';
import round from 'lodash/round';
import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';
import every from 'lodash/every';
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';

export default {
  get,
  set,
  map,
  words,
  findIndex,
  has,
  isNumber,
  toNumber,
  isEmpty,
  capitalize,
  replace,
  round,
  assign,
  cloneDeep,
  every,
  each,
  isEqual
};
